<template>
  <div>
    <div class="row mt-4">

      <div class="col-md-12 col-12 form-field">


        <div class="row">
          <div class="col-md-8 col-12" style="font-size: 20px;">
            Invoice payment details
          </div>
          <div class="col-md-4 col-12 pt-md-0 pt-4">
            <div class="row checkboxes-field">
              <label class="mb-0" for="creditMemo">
                <input type="checkbox"
                       v-model="nonPOPaymentData.creditMemo"
                       id="creditMemo"
                       @click="resetInvoiceAndCreditMemoData(currentFormName)" />
                <span class="ml-1">{{FORM_LABELS.I_HAVE_A_CREDIT_MEMO}}</span></label>
            </div>
            <div class="row font-italic pl-3">
                <span
                    :data-original-title="creditMemoToolTip"
                    data-toggle="tooltip"
                    data-container="body"
                    rel="tooltip"
                    data-placement="right"
                    data-html="true"
                    title=""
                    class="solution-link"
                ><i> {{FORM_LABELS.WHAT_IS_A_CREDIT_MEMO}}</i></span>
            </div>
          </div>
        </div>

        <div class="supplier-id-name-group-background mt-2">
          <non-p-o-autocomplete/>
        </div>

        <div class="pb-2">
          <div class="title mt-3 required-field">
            <span>{{FORM_LABELS.INVOICE_AMOUNT}} <span class="font-italic">{{FORM_LABELS.INCL_TAX_VAT_IF_ANY}}</span></span>
          </div>
          <div class="my-2">
            <div class="item select-style row px-3">
              <model-list-select
                  :list="this.adminDataList.currencyList"
                  :optionValue="'value'"
                  :optionText="'text'"
                  name="nonPOPaymentData.currency"
                  v-model="nonPOPaymentData.currency"
                  data-vv-validate-on="input"
                  class="amount-currency-field"
                  v-validate="'required'" />
              <input
                  class="form-control d-inline amount-numeric-field"
                  name="nonPOPaymentData.invoicedAmount"
                  v-model="nonPOPaymentData.invoicedAmount"
                  @blur="formatAmount({event: $event, currencyValue: nonPOPaymentData.currency, form: currentFormName, item: 'invoicedAmount' })"
                  data-vv-validate-on="input"
                  id="nonPOPaymentData.invoicedAmount"
                  autocomplete="nope"
                  v-validate.continues="{ required: true, max:maximumAmountCharLength, regex: CONSTANTS.POSITIVE_WITH_DECIMAL_AND_COMMAS }"
              >
            </div>
            <show-errors :for-item="'nonPOPaymentData.currency'" :formErrors="errors" :field-name="FORM_LABELS.CURRENCY" />
            <show-errors :for-item="'nonPOPaymentData.invoicedAmount'" :formErrors="errors" :max-length="maximumAmountCharLength" :field-name="FORM_LABELS.INVOICE_AMOUNT" />
            <validate-amount-decimals :amount="nonPOPaymentData.invoicedAmount" :currency="nonPOPaymentData.currency" @onValidationError="setInvoiceAmountInvalid" />
          </div>
        </div>

        <div class="title pt-2">
          <header-with-tooltip :tooltipText="invoiceDateToolTip" :show-icon="false">
            <span class="required-field">{{FORM_LABELS.INVOICE_DATE}}</span>
            <span class="solution-link font-italic">{{FORM_LABELS.INVOICE_DATE_HELP_TEXT}}</span>
          </header-with-tooltip>
        </div>
        <div class="mb-4 mt-1">
          <date-picker-widget
              v-model="nonPOPaymentData.invoiceDate"
              class="col-xl-3 col-12 px-0"
              name="nonPOPaymentData.invoiceDate"
              data-vv-validate-on="input"
              v-validate="'required'"
              :label="'Select date'"
              :setMinDate="false"
              :maxDate="lastDateOfMonth"
          ></date-picker-widget>
          <show-errors :for-item="'nonPOPaymentData.invoiceDate'" :formErrors="errors" :field-name="FORM_LABELS.INVOICE_DATE" />

        </div>


          <div class="title pt-2">
            <span class="required-field">{{FORM_LABELS.INVOICE_REFERENCE_NUMBER}}</span>
            <div class="mb-4 my-2">
              <input
                  class="form-control"
                  name="nonPOPaymentData.invoiceNumber"
                  v-model="nonPOPaymentData.invoiceNumber"
                  id="nonPOPaymentData.invoiceNumber"
                  autocomplete="nope"
                  data-vv-validate-on="input"
                  v-validate="{required: true, max: 16 }"
              >
              <show-errors
                  :for-item="'nonPOPaymentData.invoiceNumber'"
                  :formErrors="errors"
                  max-length="16"
                  :field-name="FORM_LABELS.INVOICE_REFERENCE_NUMBER" />
            </div>
          </div>

          <div v-show="nonPOPaymentData.creditMemo" class="title pt-2">
            <span>{{FORM_LABELS.INVOICE_REFERENCE_FOR_CREDIT_MEMO}}</span>
            <div class="mb-4 my-2">
              <input
                  class="form-control"
                  name="nonPOPaymentData.invoiceReferenceForCreditMemo"
                  v-model="nonPOPaymentData.invoiceReferenceForCreditMemo"
                  id="nonPOPaymentData.invoiceReferenceForCreditMemo"
                  autocomplete="nope"
                  data-vv-validate-on="input"
                  v-validate="{ max: 16 }"
              >
              <show-errors
                  :for-item="'nonPOPaymentData.invoiceReferenceForCreditMemo'"
                  :formErrors="errors"
                  max-length="16"
                  :field-name="FORM_LABELS.INVOICE_REFERENCE_FOR_CREDIT_MEMO" />
            </div>
          </div>

        <div class="title pt-2">
          <span class="required-field">{{FORM_LABELS.PAYMENT_DUE_DATE}}</span>
          <header-with-tooltip
              :tooltip-text="FORM_LABELS.PAYMENT_DUE_DATE_SUBDESC"
              :isHTML="true"
              :show-icon="false">{{FORM_LABELS.PAYMENT_DUE_DATE_HELP_TEXT}}</header-with-tooltip>
        </div>
        <div class="mb-4 mt-1">
          <date-picker-widget
              v-model="nonPOPaymentData.paymentDueDate"
              class="col-xl-3 col-12 px-0"
              name="nonPOPaymentData.paymentDueDate"
              data-vv-validate-on="input"
              :id="'nonPOPaymentData.paymentDueDate'"
              :label="'Select date'"
              v-validate="'required'"
              :set-min-date="true"
          ></date-picker-widget>
          <show-errors :for-item="'nonPOPaymentData.paymentDueDate'" :formErrors="errors" :field-name="FORM_LABELS.PAYMENT_DUE_DATE" />

        </div>

        <div class="pb-2" v-if="nonPOPaymentData.companyCode === CONSTANTS.INDIA_COMPANY_CODE">
          <div class="title mt-3">
            <span>{{ FORM_LABELS.SHIP_TO_LOCATION }} <span class="font-italic">{{ FORM_LABELS.FOR_INDIA_INVOICES_ONLY }}</span></span>
          </div>
          <div class="my-2">
            <div class="item select-style">
              <model-list-select
                  :list="this.adminDataList.companyBusinessPlaceList"
                  :optionValue="'value'"
                  :optionText="'text'"
                  name="nonPOPaymentData.deliveryLocation"
                  v-model="nonPOPaymentData.deliveryLocation" />
            </div>
          </div>
        </div>


        <div class="title pt-2 required-field">
          <span>{{FORM_LABELS.DESCRIPTION_OF_INVOICE}}</span>
        </div>
        <div class="mb-4">
          <textarea
              class="form-control w-100 mt-1 text-area-resize-none"
              name="nonPOPaymentData.invoiceDescription"
              v-model="nonPOPaymentData.invoiceDescription"
              data-vv-validate-on="input"
              v-validate="'required|max:50'"
          />
          <show-errors :for-item="'nonPOPaymentData.invoiceDescription'" :formErrors="errors" :field-name="'Invoice description'" :max-length="50" />

        </div>

        <div class="pb-2">
          <div class="title mt-3">
            <span class="required-field">{{FORM_LABELS.EXPENSE_TYPE}}</span>
            <header-with-tooltip
                :tooltip-text="FORM_LABELS.EXPENSE_TYPE_SUBDESC"
                :isHTML="true"
                :show-icon="false">{{FORM_LABELS.EXPENSE_TYPE_HELP_TEXT}}</header-with-tooltip>
          </div>
          <div class="my-2">
            <div class="item select-style row px-3">
              <model-list-select
                  :list="this.adminDataList.expenseTypeCodeOptions"
                  :optionValue="'value'"
                  :optionText="'text'"
                  name="nonPOPaymentData.expenseTypeCode"
                  v-model="nonPOPaymentData.expenseTypeCode"
                  @input="syncToExpenseTypeText"
                  class="amount-currency-field d-inline form-control expense-type-responsive"
                  :placeholder="'-00-'"
                  v-validate="'required'"
                  data-vv-validate-on="input"
              />
              <model-list-select
                  :list="this.adminDataList.expenseTypeTextOptions"
                  :optionValue="'value'"
                  :optionText="'text'"
                  name="nonPOPaymentData.expenseType"
                  @input="syncToExpenseTypeCode"
                  v-model="nonPOPaymentData.expenseType"
                  class="form-control d-inline amount-numeric-field expense-type-responsive"
                  :placeholder="'-Select an expense type-'"
                  v-validate="'required'"
                  data-vv-validate-on="input"
              />
            </div>
            <show-errors :for-item="'nonPOPaymentData.expenseTypeCode'" :formErrors="errors" :field-name="'Expense type'" />

          </div>
        </div>

        <div class="title pt-2">
          <span>{{FORM_LABELS.SPECIAL_INSTRUCTIONS}}</span>
          <div class="font-italic">{{FORM_LABELS.SPECIAL_INSTRUCTIONS_SUBDESC}}</div>
        </div>
        <div class="mb-4">
          <textarea
              class="form-control w-100 mt-1 text-area-resize-none"
              name="nonPOPaymentData.specialInstructions"
              v-model="nonPOPaymentData.specialInstructions"
              v-validate="'max:60'"
              data-vv-validate-on="input"
          />
          <show-errors :for-item="'nonPOPaymentData.specialInstructions'" :formErrors="errors" :field-name="'Special instructions'" :max-length="60" />


        </div>


        <div class="title pt-2">
          <span>{{FORM_LABELS.ADD_INVOICE_DETAILS}}</span>
          <span class="font-italic">{{FORM_LABELS.ADD_INVOICE_DETAILS_SUBDESC}}</span>
        </div>
        <button @click="launchAddMultipleInvoiceDetails" class="mt-2 btn-container btn flat-btn submit-btn d-md-block d-none">
          <span v-if="!invoicesAdded">Add (multiple) line items</span><span v-else>Edit or add line items</span>
        </button>
        <div
            class="text-danger input-error-text pl-1"
            v-if="showMultiInvoiceError"
        >            {{showMultiInvoiceError}}
        </div>


        <div  class="d-md-none d-block mt-2" @click="launchAddMultipleInvoiceDetails">
          <span class="solution-link" v-if="!invoicesAdded">Add (multiple) Invoice details</span>
          <span class="solution-link" v-else>Edit or add Invoice details</span>
        </div>

        <div v-if="invoicesAdded">
          <invoice-details class="mt-4"
                                            :key="componentKey"
                                            :invoices="nonPOPaymentData.invoiceItems"
                                            :currency="currencyText"
                                            :companyCode="nonPOPaymentData.companyCode"
                                            :net-amount="nonPOPaymentData.netAmount"/>
        </div>


        <div class="title pt-4">
          <span>
            {{FORM_LABELS.TAX_VAT_AMOUNT}} <span class="font-italic">{{ FORM_LABELS.OPTIONAL }}</span>
          </span>
        </div>
        <div class="mb-4 my-2 row no-gutters">
          <input class="form-control amount-currency-field text-center" readonly :placeholder="currencyText" />
          <input
              class="form-control amount-numeric-field pl-1"
              name="nonPOPaymentData.taxAmount"
              v-model="nonPOPaymentData.taxAmount"
              id="nonPOPaymentData.taxAmount"
              @blur="formatAmount({event: $event, currencyValue: nonPOPaymentData.currency, form: currentFormName, item: 'taxAmount' })"
              autocomplete="nope"
              v-validate.continues="{ max:13, regex: CONSTANTS.POSITIVE_WITH_DECIMAL_AND_COMMAS }"
          >
          <show-errors :for-item="'nonPOPaymentData.taxAmount'" :formErrors="errors" :field-name="FORM_LABELS.TAX_VAT_AMOUNT" :max-length="13" />
          <validate-amount-decimals :amount="nonPOPaymentData.taxAmount" :currency="nonPOPaymentData.currency" @onValidationError="setTaxAmountInvalid" />

        </div>

        <div class="title pt-2">
          <span>
            {{ FORM_LABELS.TOTAL_AMOUNT }}
          </span>
          <div class="font-italic">
            {{ FORM_LABELS.TOTAL_AMOUNT_SUBDESC }}
          </div>
        </div>
        <div class="mb-4 my-2 row no-gutters">
          <input class="form-control amount-currency-field text-center" readonly :placeholder="currencyText" />
          <input
              class="form-control amount-numeric-field pl-1"
              name="nonPOPaymentData.totalAmount"
              v-model="nonPOPaymentData.totalAmount"
              id="nonPOPaymentData.totalAmount"
              autocomplete="nope"
              :disabled="true"
              :key="componentKey"
          >
        </div>


        <div ref="unmatchedAmountError">
          <div v-if="(getFloatValue(nonPOPaymentData.unmatchedAmount) > 0 || getFloatValue(nonPOPaymentData.unmatchedAmount) < 0) && showUnmatchedAmountError">
            <span class="text-danger input-error-text">
              There is an unmatched amount of <strong> <span v-if="currencyText">{{currencyText}}</span>
              {{nonPOPaymentData.unmatchedAmount}}</strong>. Please correct the amount.
            </span>
            <div>
              Unmatched amount is {{FORM_LABELS.UNMATCHED_AMOUNT_SUBDESC}}
            </div>
            <div>
              Invoice amount: <strong>{{currencyText}} {{nonPOPaymentData.invoicedAmount}}</strong> <br />
              Total amount = Net amount + Tax amount: <strong>{{currencyText}} {{nonPOPaymentData.totalAmount}}</strong>
            </div>
          </div>
        </div>

        <div v-if="isExpenseTypeTIOrTD">
          <assignment-and-doc-header-text-input :form="currentFormName" />
        </div>
        <div class="pt-2">
          <attach-invoice :data="nonPOPaymentData" @onInvoiceUploaded="onInvoiceUploaded($event, currentFormName)"
                          @onInvoiceDeleted="onInvoiceDeleted($event, currentFormName)"
                          :viewAttachment="true"
                          :multipleSelectionAllowed="true"
                          :max-file-size-in-mb="CONSTANTS.ATTACHMENTS_MAX_SIZE_IN_MB.INVOICE_PAYMENT_FORMS"
                          :is-required="true"
                          :attachment-title="CONSTANTS.ATTACH_AN_INVOICE"
                          :validFileTypes="CONSTANTS.FILE_TYPES.extensionAsPdf.validFileTypes"
                          :check-for-file-support="true" />
          <div class="text-danger input-error-text" v-if="showHelpTextForGermany">
            <b>XML e-invoice</b> is not accepted, please request and submit <b>PDF</b> format invoice.
          </div>
          <div class="text-danger input-error-text" v-if="showAttachmentsError">
            Invoice attachment is required
          </div>
        </div>



        <div class="float-md-right mt-4 pr-0">
          <button class="btn-container flat-btn gray-btn close-btn btn mx-2 my-3" @click="navigateToHome">Cancel</button>
          <button class="btn btn-outline-info outline-flat-btn submit-btn" @click="validateAndSetDraftRequest">Save Draft</button>
          <button class="btn-container btn flat-btn primary-blue-btn ml-2 my-3" @click="validateMultiInvoices">Next</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { ModelListSelect } from "vue-search-select";
import DatePickerWidget from "@/components/DatePicker";
import AddMultipleInvoiceDetails from "@/components/Payments/NonPOBasedPayment/AddMultipleInvoiceDetails";
import { mapGetters,mapMutations } from "vuex"
import InvoiceDetails from "@/components/Payments/NonPOBasedPayment/InvoiceDetails";
import PaymentFormsMixin from "@/mixins/PaymentFormsMixin";
import AttachInvoice from "../AttachInvoice";
import CONSTANTS from "@/store/constants";
import AssignmentAndDocHeaderTextInput from "@/components/Payments/AssignmentAndDocHeaderTextInput";
import HeaderWithTooltip from "@/components/HeaderWithTooltip";
import NonPOAutocomplete from "./NonPOAutocomplete";

export default {
  name: "NonPOPaymentQuestionnaireOne",
  components: {
    NonPOAutocomplete,
    AssignmentAndDocHeaderTextInput, DatePickerWidget, ModelListSelect, AttachInvoice, InvoiceDetails, HeaderWithTooltip},

  mixins: [PaymentFormsMixin],
  data() {
    return {
      componentKey: 0,
      currencyValue: '',
      invoicesAdded: false,
      showMultiInvoiceError: false,
      showUnmatchedAmountError: false,
      showHelpTextForGermany: false,
    }
  },
  mounted() {
    if(!this.isFormDataLoaded && !this.isContinueDraftClicked) {
      this.resetNonPOPaymentData()
    } else {
      if(this.nonPOPaymentData.invoiceItems && this.nonPOPaymentData.invoiceItems.length > 0) {
        this.invoicesAdded = true
      }
      if(this.nonPOPaymentData && this.nonPOPaymentData.companyCode){
        this.showHelpTextForGermany = this.nonPOPaymentData.companyCode == "2060"
      }
    }
    // po number not applicable here
    this.setIsInvalidPoNumber(false)
  },
  watch: {
    "nonPOPaymentData.taxAmount"(){
      this.nonPOPaymentData.totalAmount = this.validateTotalAmount(this.nonPOPaymentData,false)
    },
    unmatchedAmount(newVal) {
        this.nonPOPaymentData.unmatchedAmount = this.updateAmount(newVal, this.allowedDecimals(this.nonPOPaymentData,false))
    },
    "nonPOPaymentData.currency"(newVal) {
      //Watch for currency changes and adjust decimal value accuracy by fetching decimal amount from the list
      if(newVal) {
        let allowedDecimals = this.adminDataList.currencyList.find(currency => currency.value === newVal).decimal
        this.setAllAmountsToFixedDecimal(allowedDecimals)
        if(this.nonPOPaymentData.companyCode && this.nonPOPaymentData.companyCode.length > 0)
        this.showMultiInvoiceError = false
      }
    },
    "nonPOPaymentData.companyCode"(newVal) {
      if(newVal) {
        this.showHelpTextForGermany = this.nonPOPaymentData.companyCode == "2060"
        if(this.nonPOPaymentData.currency && this.nonPOPaymentData.currency.length > 0)
          this.showMultiInvoiceError = false
      }
    },
  },
  computed: {
    ...mapGetters(['nonPOPaymentData', 'isFormDataLoaded','isContinueDraftClicked']),
    isAllAmountsValid() {
      return !this.isInvoiceAmountInvalid && !this.isTaxAmountInvalid
    },
    currencyText() {
      return this.getTextValue(this.adminDataList.currencyList,this.nonPOPaymentData.currency)
    },
    isExpenseTypeTIOrTD() {
      //Expose Tax related form only if expenseType belongs to Tax Direct or Tax Indirect fields.
      let expenseTypeCode = this.getTextValue(this.adminDataList.expenseTypeCodeOptions, this.nonPOPaymentData.expenseTypeCode)
      return  CONSTANTS.TAX_FIELDS.includes(expenseTypeCode)
    },
    unmatchedAmount() {
      let unmatchedAmount = 0
      if (this.getFloatValue(this.nonPOPaymentData.invoicedAmount) > 0 && this.getFloatValue(this.nonPOPaymentData.totalAmount) > 0) {
        unmatchedAmount = this.getFloatValue(this.nonPOPaymentData.invoicedAmount) - this.getFloatValue(this.nonPOPaymentData.totalAmount)
        return unmatchedAmount
      } else {
        return unmatchedAmount
      }
    },

  },
  methods: {
    ...mapMutations(["setIsFormDataLoaded"]),
    setAllAmountsToFixedDecimal(allowedDecimals) {
      // set all amounts to fixed allowed amounts based on allowed Decimal values
      this.nonPOPaymentData.invoicedAmount = this.isValidNumber(this.nonPOPaymentData.invoicedAmount) ?
          this.updateAmount(this.nonPOPaymentData.invoicedAmount, allowedDecimals) : this.nonPOPaymentData.invoicedAmount
      this.nonPOPaymentData.unmatchedAmount = this.isValidNumber(this.nonPOPaymentData.unmatchedAmount) ?
          this.updateAmount(this.nonPOPaymentData.unmatchedAmount, allowedDecimals) : this.nonPOPaymentData.unmatchedAmount
      this.nonPOPaymentData.totalAmount = this.isValidNumber(this.nonPOPaymentData.totalAmount) ?
          this.updateAmount(this.nonPOPaymentData.totalAmount, allowedDecimals) : this.nonPOPaymentData.totalAmount
      this.nonPOPaymentData.taxAmount = this.isValidNumber(this.nonPOPaymentData.taxAmount) ?
          this.updateAmount(this.nonPOPaymentData.taxAmount, allowedDecimals) : this.nonPOPaymentData.taxAmount
      this.nonPOPaymentData.netAmount = this.isValidNumber(this.nonPOPaymentData.netAmount) ?
          this.updateAmount(this.nonPOPaymentData.netAmount, allowedDecimals) : this.nonPOPaymentData.netAmount
      if(this.nonPOPaymentData.invoiceItems && this.nonPOPaymentData.invoiceItems.length > 0) {
        this.nonPOPaymentData.invoiceItems.forEach(invoice => {
          invoice.itemTotal = this.isValidNumber(invoice.itemTotal) ? this.updateAmount(invoice.itemTotal, allowedDecimals) : invoice.itemTotal
        })
      }
    },
    syncToExpenseTypeText(item) {
      this.nonPOPaymentData.expenseType = item
    },
    syncToExpenseTypeCode(item) {
      this.nonPOPaymentData.expenseTypeCode = item
    },
    validateMultiInvoices() {
      this.showAttachmentsError = !this.formAttachmentsExist(this.currentFormName)

      if(this.invoicesAdded) {
        if((this.getFloatValue(this.nonPOPaymentData.unmatchedAmount) < 0)
            || (this.getFloatValue(this.nonPOPaymentData.unmatchedAmount) > 0)) {
          this.showUnmatchedAmountError = true
          this.$refs.unmatchedAmountError.scrollIntoView({behavior: "smooth"})
        } else if(this.isAllAmountsValid && !this.showAttachmentsError) {
          this.validateAndSetCurrentTab('PaymentDetailsForm')
        } else {
          window.scrollTo(0,0)
          this.$validator.validateAll()
        }
      } else {
        this.$validator.validateAll().then(() => {
          window.scrollTo(0,0)
          this.showMultiInvoiceError = CONSTANTS.MULTI_INVOICES_ERROR_MESSAGE
        })
      }
    },
    validateAndSetDraftRequest(){
      this.$validator.attach({ name: "nonPOPaymentData.companyCode", rules: "required"});
      this.$validator.validate('nonPOPaymentData.companyCode',this.nonPOPaymentData.companyCode).then(result => {
        if (result) {
          this.saveDraftNonPOBasedPaymentRequest(true)
          //setIsFormDataLoaded is set to true to make sure that on first save to draft, the form in the background does not lose data in the form.
          this.setIsFormDataLoaded(true)
          //detach is for scenario when -- if none of the fields is entered, and save as draft is clicked , which attaches below validation , and if we press next after filling the fields
          //it will still show error, hence detach.
          this.$validator.detach("nonPOPaymentData.companyCode")
        }else{
          window.scrollTo(0,0)
        }
      });
    },
    launchAddMultipleInvoiceDetails() {
      if(this.nonPOPaymentData.currency && this.nonPOPaymentData.companyCode) {
        document.documentElement.style.overflow = "hidden";
        let invoiceDetails = {
          invoiceItems: this.nonPOPaymentData.invoiceItems,
          currency: this.nonPOPaymentData.currency,
          netAmount: this.nonPOPaymentData.netAmount,
          costCenterPrefix: this.nonPOPaymentData.companyCode
        }
        this.$modal.show(
            AddMultipleInvoiceDetails,
            {
              invoiceDetails: invoiceDetails
            },
            {
              adaptive: true,
              height: "540",
              width: "1200"
            },
            {
              closed: () => {
                document.documentElement.style.overflow = "auto";
                this.showMultiInvoiceError = ''
                this.componentKey++
              },
              "invoicesAdded": (item) => {
                if(item.invoiceDetails.invoiceItems && item.invoiceDetails.invoiceItems.length > 0) {
                  this.nonPOPaymentData.invoiceItems = JSON.parse(JSON.stringify(item.invoiceDetails.invoiceItems))
                  this.invoicesAdded = true
                  this.showMultiInvoiceError = ''
                  this.nonPOPaymentData.netAmount = item.invoiceDetails.netAmount
                  this.nonPOPaymentData.totalAmount = this.validateTotalAmount(this.nonPOPaymentData,false)
                  this.componentKey++
                } else {
                  this.nonPOPaymentData.invoiceItems = JSON.parse(JSON.stringify(item.invoiceDetails.invoiceItems))
                  this.showMultiInvoiceError = CONSTANTS.MULTI_INVOICES_ERROR_MESSAGE
                  this.invoicesAdded = false
                }
              }
            }
        );
      } else {
        this.showMultiInvoiceError = CONSTANTS.MULTI_INVOICE_COMPANY_CODE_CURRENCY_REQUIRED
      }

    }
  },

}

</script>

<style scoped>
.preview-notification {
  margin-left: 0
}

.select-style >>> .ui.selection.dropdown .menu  {
  max-height: 150px;
}


.checkboxes-field label {
  display: block;
  padding-right: 10px;
  padding-left: 22px;
  text-indent: -22px;
}
.checkboxes-field input {
  vertical-align: middle;
}
.checkboxes-field label span {
  vertical-align: middle;
}

.currency-select {
  max-width: 70px;
}

@media (max-width: 768px) {
  .expense-type-responsive {
    height: 50px;
  }
}

.supplier-id-name-group-background {
  background-color: #F0F7FE !important;
  padding: 10px 20px;
}
</style>

<style scoped src="@/assets/stylesheets/vueSearchSelectOverrides.css">

</style>